'use client'

import { defaultAppConfig } from './appConfig'
import { createAppConfigContext } from 'app-config-utils/client-side/createAppConfigContext'
import type { ComponentProps } from 'react'

const [Provider, useAppConfigContext] = createAppConfigContext(defaultAppConfig.config)

/**
 * Read the active per-locale app config from React context. Returns the
 * per-request dynamic config provided by the layout (`getDynamicAppConfig`),
 * falling back to the default-locale build-time config outside a provider.
 * Prefer this over calling `appConfig(locale).config` directly in client
 * components that must reflect live store settings (logo, theme, labels, etc.).
 */
export { useAppConfigContext }

/**
 * Wrapper around the context provider created by `createAppConfigContext`.
 *
 * This extra component is necessary because JSX and React (especially with Next.js)
 * require component types to be statically analyzable. Directly exporting a component
 * from array destructuring does not work with React's rendering pipeline.
 */
export const AppConfigContextProvider = ({ value, children }: ComponentProps<typeof Provider>) => {
  return <Provider value={value}>{children}</Provider>
}
